import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import { styled } from '@mui/material';

type StyledTreeItemProps = {
  rootnode?: boolean;
};

export const StyledTreeItem = styled(TreeItem)<StyledTreeItemProps>(({
  rootnode,
}) => {
  const borderColor = '#e0e0e0';

  return {
    backgroundColor: 'white',
    position: 'relative',
    [`& .${treeItemClasses.iconContainer}`]: {
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: 20,
        left: -18,
        top: '50%',
        transform: 'translateY(-50%)',
        borderBottom: !rootnode ? `1px solid ${borderColor}` : 'none',
      },
    },

    [`& .${treeItemClasses.root}`]: {
      '&:hover': {
        backgroundColor: 'white',
      },
    },

    [`& .${treeItemClasses.group}`]: {
      marginLeft: 8,
      paddingLeft: 18,
      borderLeft: `1px solid ${borderColor}`,
    },
    [`& .${treeItemClasses.content}`]: {
      padding: 0,
      '&:hover': {
        backgroundColor: 'white',
      },
      '&.Mui-selected': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'white',
        },
        '&.Mui-focused': {
          backgroundColor: 'white',
        },
      },
      '&.Mui-focused': {
        backgroundColor: 'white',
      },
    },
  };
});
